import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import { formatMedicinePackage } from '~libs.shared.medicine';

import { StyledMedicinePackage } from './MedicinePackage.styled';

export type MedicinePackageProps = Pick<MedicineSimple, 'form' | 'dose' | 'packageContent' | 'valid'>;

export const MedicinePackage = (props: MedicinePackageProps): JSX.Element => {
   const valid = props.valid !== false;

   return (
      <StyledMedicinePackage {...appendTestableElementAttributes('medicinePackage')} $valid={valid}>
         {formatMedicinePackage(props)}
      </StyledMedicinePackage>
   );
};
